// 追従(CookiePolicy)の表示 // Display follow (CookiePolicy)
jQuery(function($) {
	
	if ( $('#cookiePolicy').length > 0 ) {
		var cookiePolicy = $('#cookiePolicy');  
		cookiePolicy.hide();
		if(localStorage.getItem('cookieUse') === null) {

			// スクロール時の表示・非表示 // show/hide on scrolling
			$(window).on("scroll", dispAgree);

			// 同意ボタンクリック // click on the agree button
			$('#cookie_agree').on("click", function() {
				$(window).off("scroll", dispAgree);
				localStorage.setItem('cookieUse', 'agree');
				cookiePolicy.hide();
			})
		}

		//スクロールが100に達したらクッキー同意を表示 // Show cookie agreement when scroll reaches 100
		function dispAgree() {
			if ($(this).scrollTop() > 100) {
				cookiePolicy.fadeIn();
			} else {
				cookiePolicy.fadeOut();
			}
		}
	}

	
});

// ページ内アンカーリンクのスクロールエフェクト // Scrolling effect for anchor links within the page
// ヘッダーが固定の場合はheaderHightにヘッダーの高さを設定(PC/SP要設定) // Set header height to headerHight if header is fixed (PC/SP setting required)
jQuery(function($) {
    var headerHeight = 0; // ヘッダー追従でない場合 // if not header-following
	// var headerHeight = $('header').innerHeight(); // ヘッダー追従の場合 // if header following
    $('a[href^="#"]').click(function(){
        var href= $(this).attr("href");
        var target = $(href == "#" || href == "" ? 'html' : href);
        if ( target.length > 0 ) {
            var position = target.offset().top - headerHeight;
            $("html, body").animate({scrollTop:position}, 550, "swing");
            return false;
        }
    });
})



// ページトップボタンの表示 // Display the page top button
jQuery(function($) {
	
	if ( $('#pageup').length > 0 ) {
		var topBtn = $('#pageup');    
		var cta = $('#cta');
		topBtn.css("display", "none");
		cta.css("display", "none");
		//スクロールが100に達したらボタン表示 // display button when scroll reaches 100
		$(window).scroll(function () {
			if ($(this).scrollTop() > 200) {
				topBtn.fadeIn();
				cta.fadeIn();
			} else {
				topBtn.fadeOut();
				cta.fadeOut();
			}
		});
		//スクロールしてトップ // scroll to the top
		topBtn.click(function () {
			$('body,html').animate({
				scrollTop: 0
			}, 500);
			return false;
		});
	}
});


// ヘッダーの固定エフェクト // Fixed header effect
// jQuery(function($) {
// 	var $header = $('header');
// 	$(window).scroll(function() {
// 		if ($(window).scrollTop() > 50) {
// 			$header.addClass('fixed');
// 		} else {
// 			$header.removeClass('fixed');
// 		}
// 	});
// });



// トップスライダーの起動 // Launch the top slider

const swiper = new Swiper(".js-swiper", {
	speed: 600, // スライド変化時間
	loop: false,
	pagination: {
	  el: ".swiper-pagination",
	  type: "bullets",
	  clickable: true,
	},
	navigation: {
	  nextEl: ".swiper-button-next",
	  prevEl: ".swiper-button-prev",
	},
  });
  